export default __webpack_public_path__ + "static/media/arrow-slider-left.9879e87f.svg";